// Mid-grey contrast with a continuous shadow toe. A linear pivot subtracts
// light from dark pixels and clips an entire twilight band to zero.
export const CONTRAST_GLSL = /* glsl */`
vec3 photographicContrast(vec3 colour, float amount) {
  vec3 c = max(colour, vec3(0.0));
  float k = max(amount, 0.001);
  vec3 shadow = 0.5 * pow(min(c * 2.0, vec3(1.0)), vec3(k));
  vec3 highlight = (c - 0.5) * k + 0.5;
  // Both branches meet at 0.5 with derivative k. Black stays exactly
  // black, positive twilight stays positive, and HDR highlights stay linear.
  return mix(shadow, highlight, step(vec3(0.5), c));
}
`;
